export default __webpack_public_path__ + "searchOsm.min.css";